export const GET_ALL_AWARD_REQUEST = "GET_ALL_AWARD_REQUEST";
export const GET_ALL_AWARD_SUCCESS = "GET_ALL_AWARD_SUCCESS";
export const GET_ALL_AWARD_FAILURE = "GET_ALL_AWARD_FAILURE";


export const GET_AWARD_RECIPIENTS_LIST_REQUEST = "GET_AWARD_RECIPIENTS_LIST_REQUEST";
export const GET_AWARD_RECIPIENTS_LIST_SUCCESS = "GET_AWARD_RECIPIENTS_LIST_SUCCESS";
export const GET_AWARD_RECIPIENTS_LIST_FAILURE = "GET_AWARD_RECIPIENTS_LIST_FAILURE";